module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_123.75deg.34bef36b.png";